<template>
  <svg
    id="Capa_1"
    enable-background="new 0 0 512 512"
    height="512"
    viewBox="0 0 512 512"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="m211.215 58.332c-47.977 0-87.008 39.037-87.008 87.02s39.032 87.02 87.008 87.02 87.008-39.037 87.008-87.02-39.032-87.02-87.008-87.02zm0 154.042c-36.949 0-67.009-30.065-67.009-67.021s30.06-67.021 67.009-67.021 67.009 30.065 67.009 67.021-30.06 67.021-67.009 67.021z"
      />
      <path
        d="m435.002 32.879c-5.522 0-10 4.478-10 10v3.141s-49.531 24.788-67.541 27.798c-8.258 1.38-12.479-4.538-20.98-13.617-5.084-5.43-11.412-12.187-20.291-18.774-11.021-8.266-20.222-15.045-29.887-20.751-30.173-18.351-65.049-24.659-100.918-18.232-57.307 10.564-103.614 55.628-115.231 112.137-2.094 10.206-3.156 20.567-3.156 30.794 0 33.988 11.244 65.699 32.5 91.684 16.108 19.792 36.727 34.683 59.79 43.691l-25.751 105.19c-4.266 17.424-.361 35.511 10.713 49.622 11.074 14.112 27.713 22.205 45.652 22.205h3.054c1.791 30.208 26.933 54.233 57.581 54.233 31.808 0 57.685-25.877 57.685-57.684v-126.812c0-16.181 13.164-29.344 29.344-29.344 16.181 0 29.345 13.164 29.345 29.344v165.199c0 5.522 4.478 10 10 10s10-4.478 10-10v-165.199c0-27.208-22.136-49.343-49.344-49.343s-49.343 22.135-49.343 49.343v126.812c0 20.779-16.905 37.686-37.686 37.686-19.616 0-35.78-15.066-37.528-34.233h2.23c18.02 0 34.705-8.153 45.779-22.368 11.073-14.216 14.896-32.389 10.486-49.86l-24.98-98.979c13.343-3.276 26.146-8.465 37.968-15.446 16.861-8.797 45.08-30.819 52.635-39.445 9.633-9.629 14.773-16.472 24.401-14.736 17.03 3.072 63.473 27.61 63.473 27.61v7.008c0 5.522 4.478 10 10 10s10-4.478 10-10v-208.674c0-5.522-4.478-10-10-10zm-182.889 357.554c2.891 11.45.386 23.36-6.872 32.677-7.257 9.316-18.191 14.659-30.001 14.659h-25.339c-11.757 0-22.66-5.305-29.918-14.553s-9.816-21.102-7.021-32.52l25.451-103.967c10.969 2.611 22.324 3.963 33.876 3.963 4.849 0 9.678-.244 14.468-.728zm115.37-192.72c-1.293-.478-2.57-.702-3.989-.83-19.774-1.786-29.885 10.026-40.504 20.641-10.429 10.377-33.374 27.256-48.633 36.35-18.631 11.002-40.095 16.816-62.067 16.816-37.898 0-73.355-16.859-97.296-46.276-18.314-22.388-27.996-49.72-27.996-79.04 0-8.88.925-17.888 2.747-26.77 9.993-48.612 49.885-87.391 99.218-96.486 7.887-1.412 15.711-2.113 23.429-2.113 22.585 0 44.229 6.011 63.573 17.787.04.024.079.049.12.072 8.803 5.192 17.564 11.653 28.146 19.589 7.473 5.546 12.882 11.321 17.652 16.415 9.632 10.285 18.264 20.28 36.963 20.118 1.382-.012 3-.363 4.271-.873l61.886-25.47v155.087c0 .003-42.813-19.577-57.52-25.017z"
      />
      <path
        d="m205.045 342.281c-5.522 0-10 4.478-10 10v36.255c0 5.522 4.478 10 10 10s10-4.478 10-10v-36.255c-.001-5.522-4.479-10-10-10z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "hair_dryer",
};
</script>

<style scoped>
svg {
  fill: currentColor;
}
</style>
